export const getRoleDashboardPath = (user) => {
  if (!user) return "/";

  switch (user.role) {
    case "admin":
    case "developer":
    case "broker":
    case "owner":
    case "basic":
    default:
      return "/dashboard";
  }
};

export const resolveBackFallbackPath = (user, explicitFallback) => {
  if (explicitFallback) return explicitFallback;
  return getRoleDashboardPath(user);
};
